﻿{
  "version": 1,
  "gameId": "durak",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0 },
  "cosmetics": {},
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "durak.rules.navigationLabel",
    "kickerKey": "durak.rules.kicker",
    "titleKey": "durak.rules.title",
    "summaryKey": "durak.rules.summary",
    "sections": [
      { "id": "deal", "key": "durak.rules.deal" },
      { "id": "attack", "key": "durak.rules.attack" },
      { "id": "defend", "key": "durak.rules.defend" },
      { "id": "take", "key": "durak.rules.take" },
      { "id": "refill", "key": "durak.rules.refill" },
      { "id": "finish", "key": "durak.rules.finish" }
    ],
    "settingsAccess": false
  }
}
